import React, { useEffect, useState } from "react";

import { NavLink, Outlet, useNavigate } from "react-router-dom";

import { useSuperAuth } from "@/contexts/SuperAuthContext";

import { superApi } from "@/lib/superApi";

import { LogOut, Shield, Building2, Layers, RefreshCw, Rocket, CreditCard } from "lucide-react";



export default function SuperLayout() {

  const { logout, user } = useSuperAuth();

  const nav = useNavigate();

  const [bootstrapped, setBootstrapped] = useState(null);

  const [platform, setPlatform] = useState(null);



  useEffect(() => {

    superApi.get("/super/platform").then((r) => {

      setBootstrapped(!!r.data?.bootstrapped);

      setPlatform(r.data);

    }).catch(() => setBootstrapped(false));

  }, []);



  const handleLogout = () => {

    logout();

    nav("/super/login");

  };



  const navItem = ({ isActive }) =>

    `flex items-center gap-2 px-3 py-2 rounded-sm border transition-colors ${

      isActive

        ? "border-[#FFD700]/50 bg-[#FFD700]/10 text-[#FFD700]"

        : "border-transparent text-white/60 hover:text-white hover:bg-white/5"

    }`;



  const quotaLabel = platform

    ? platform.max_branches == null

      ? `${platform.branch_count} sucursales`

      : `${platform.branch_count}/${platform.max_branches} sucursales`

    : "";



  return (

    <div className="min-h-screen bg-[#0A0A0A] text-white">

      <header className="border-b border-white/10 px-6 py-4 flex items-center justify-between gap-4 flex-wrap">

        <div className="flex items-center gap-3">

          <Shield className="text-[#FFD700]" size={22} />

          <div>

            <span className="font-display text-2xl">Super Administrador</span>

            {platform?.plan_name && (

              <div className="text-xs text-white/60 mt-0.5">

                {platform.plan_name} · {quotaLabel}

                {platform.admin_licensed ? " · Panel admin activo" : " · Panel admin inactivo"}

              </div>

            )}

          </div>

        </div>

        <div className="flex items-center gap-4 text-sm text-white/60">

          <span>{user?.email}</span>

          <button onClick={handleLogout} className="btn-outline text-xs py-2 flex items-center gap-1">

            <LogOut size={14} /> Salir

          </button>

        </div>

      </header>



      {bootstrapped !== null && (

        <nav className="px-6 py-3 border-b border-theme-secondary/10 flex flex-wrap gap-2 text-sm">

          {!bootstrapped && (

            <NavLink to="/super/inicio" className={navItem}>

              <Rocket size={15} /> Configurar cliente

            </NavLink>

          )}

          {bootstrapped && (

            <>

              <NavLink to="/super/cliente" className={navItem}>

                <Building2 size={15} /> Plan comercial

              </NavLink>

              <NavLink to="/super/suscripcion" className={navItem}>

                <CreditCard size={15} /> Suscripción y cobros

              </NavLink>

              <NavLink to="/super/modulos" className={navItem}>

                <Layers size={15} /> Módulos por sucursal

              </NavLink>

              <NavLink to="/super/reinicio" className={navItem}>

                <RefreshCw size={15} /> Reinicio

              </NavLink>

            </>

          )}

        </nav>

      )}



      <main className="p-6 max-w-4xl">

        <Outlet />

      </main>

    </div>

  );

}

